import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '1rem 0',
  },
  loading: {
    width: '100%',
    padding: 0,
  },
});
const PageSubtitle = ({text, isLoading=false}) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <Skeleton animation="wave" height={80}/>
      </div>
    );
  }

  return (
    <Typography
      variant="h1"
      color="primary"
      className={classes.root}
    >
      {text}
    </Typography>
  );
};

PageSubtitle.propTypes = {
  text: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
};

export default PageSubtitle;
